import { useTranslation } from "@opendash/i18n";
import { DatePicker, Flex, Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import React from "react";
import { MediaInput } from "../../../_shared/media/components/MediaInput";
import { Media } from "../../../js/parsegenerated";

export type MessageValueType = {
  date: Dayjs;
  title: string;
  description: string;
  /**
   * The media objects are not saved here!
   */
  media: Media[];
};

type Props = {
  name: string;
};

export const MessageFormItems = observer((props: Props) => {
  const t = useTranslation();

  return (
    <Flex gap="16px" vertical>
      <Form.Item
        name={[props.name, "title"]}
        label={t("maintenance:message.input.title.label")}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name={[props.name, "description"]}
        label={t("maintenance:message.input.description.label")}
        rules={[{ required: true }]}
      >
        <TextArea rows={4} />
      </Form.Item>

      <Form.Item
        name={[props.name, "date"]}
        label={t("maintenance:message.input.date.label")}
      >
        <DatePicker showTime style={{ display: "block" }} />
      </Form.Item>

      <Form.Item
        name={[props.name, "media"]}
        label={t("maintenance:message.input.media.label")}
      >
        <MediaInput />
      </Form.Item>
    </Flex>
  );
});
